module.exports = __webpack_public_path__ + "static/todd-jones.811a0ede.webp";